/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TopDrinkDto } from '../../models/top-drink-dto';

export interface DrinkStatsControllerGetTopDrinks$Params {
  dateFrom?: string;
  dateTo?: string;
}

export function drinkStatsControllerGetTopDrinks(http: HttpClient, rootUrl: string, params?: DrinkStatsControllerGetTopDrinks$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TopDrinkDto>>> {
  const rb = new RequestBuilder(rootUrl, drinkStatsControllerGetTopDrinks.PATH, 'get');
  if (params) {
    rb.query('dateFrom', params.dateFrom, {});
    rb.query('dateTo', params.dateTo, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TopDrinkDto>>;
    })
  );
}

drinkStatsControllerGetTopDrinks.PATH = '/drink-stats/top-drinks';
